import { InjectionToken } from '@angular/core';
import { SelectConfig } from '../types/select.type';

/**
 * Injection token that can be used to provide the default options the select module.
 */
export const SELECT_CONFIG = new InjectionToken<SelectConfig>('SELECT_CONFIG');
